import { render, staticRenderFns } from "./SnapshotConfirm.vue?vue&type=template&id=78960f4f"
import script from "./SnapshotConfirm.vue?vue&type=script&lang=js"
export * from "./SnapshotConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports